module.exports = __webpack_public_path__ + "7cc608b2d419ca39dd2e5745907ed3f8.svg";